import { Div, List, ListItem, P } from '@kizi/core-components';
import { Accordion } from '@kizi/shared-components';
import React from 'react';
import { DetailsTabProps } from '.';
import { DocumentUrl } from '../../../../DocumentUrl';
import { ListComp } from '../../../../Product/ExpandedPart/List';

export const DetailsTabTravel: React.FC<DetailsTabProps> = ({ data }) => {
  const { /*fees = [], */ coverageTravels, productType, provider } = data;
  const {
    insuranceCardUrl = '',
    termsAndConditionsUrl = '',
    // name: providerName,
  } = provider;

  // const coverageAreaCode = useField('getUserInput.coverageAreaCode');
  // const numberOfDaysCoverage = useField('getUserInput.numberOfDaysCoverage');

  // function getGroupByFees(list: Field[], title: string): ListGroup[] {
  //   let coverageDaysValue = numberOfDaysCoverage?.value;
  //   list.forEach((element) => {
  //     if (element.label === 'Dekkingsgebied') {
  //       element.value = coverageAreaCode?.value === 'VX' ? 'Europa' : 'Wereld';
  //     }
  //     if (element.label === 'Reisduur') {
  //       switch (coverageDaysValue) {
  //         case '45':
  //           element.value = 'Maximaal 6 weken';
  //           break;
  //         case '60':
  //           element.value = 'Maximaal 2 maanden';
  //           break;
  //         case '90':
  //           element.value = 'Maximaal 3 maanden';
  //           break;
  //         case '180':
  //           element.value = 'Maximaal 6 maanden';
  //           break;
  //         default:
  //           element.value = 'Maximaal 12 maanden';
  //       }
  //     }
  //   });
  //   return list.length ? [{ list, title }] : [];
  // }

  // let travelFees = fieldByCategory(fees, 'TRAVEL');
  // let stringifiedTravelFees = JSON.stringify(travelFees).replace(
  //   'Max reisduur std (dgn)',
  //   'Reisduur'
  // );
  // travelFees = JSON.parse(stringifiedTravelFees);

  // const bagageCoverage = fees.find((fee) => fee.label === 'Dekking bagage');
  // const goldCoverage = fees.find((fee) => fee.label === 'Dekking geld/cheques');
  // const cancellationCoverage = fees.find(
  //   (fee) => fee.label === 'Dekking (type annulering)'
  // );

  const urlLabel = getLabelByType(productType);

  const coveragesData = [
    {
      label: 'Basisdekking',
      icon: 'green-check',
      content:
        'De basisdekking bestaat onder andere uit: vergoeding van hulpverlening en noodhulp. De inhoud van de basisdekking verschilt per verzekeraar.',
    },
    ...(coverageTravels?.luggageAdditionallyInsured === true
      ? [
          {
            label: 'Bagage',
            icon: 'green-check',
            content:
              'Met deze dekking is je bagage verzekerd voor diefstal, verlies of beschadiging.',
          },
        ]
      : []),
    ...(coverageTravels?.moneyChequesAdditionallyInsured === true
      ? [
          {
            label: 'Geld',
            icon: 'green-check',
            content:
              'Wanneer je op vakantie bestolen wordt, dan is met deze dekking je contante geld verzekerd.',
          },
        ]
      : []),
    ...(coverageTravels?.cancellationAdditionallyInsured === true
      ? [
          {
            label: 'Annulering',
            icon: 'green-check',
            content:
              'Hiermee krijg je kosten vergoed als je onverwacht je reis moet annuleren, of eerder terug naar huis moet.',
          },
        ]
      : []),
    ...(coverageTravels?.medicalCostsAdditionallyInsured === true ||
    coverageTravels?.costsMedicalTreatmentAdditionallyInsured === true
      ? [
          {
            label: 'Medische kosten',
            icon: 'green-check',
            content:
              'Met de extra dekking medische kosten vergroot je je medische dekking in het buitenland. Hierdoor heb je vaak een uitgebreidere verzekering dan wanneer je alleen een aanvullende zorgverzekering hebt, want daarmee worden alleen de kosten van spoedeisende medische zorg die in Nederland gelden vergoed.',
          },
        ]
      : []),
    ...(coverageTravels?.exceptionalCostsAdditionallyInsured === true
      ? [
          {
            label: 'Ongevallen',
            icon: 'green-check',
            content:
              'Met de wintersportverzekering ben je ook tijdens het skiën of snowboarden gedekt door je bestaande verzekeringen. Hierdoor ben je beschermd bij schade, verlies of diefstal van je wintersportuitrusting. Je bent ook verzekerd voor de nodige hulpverlening, niet-gebruikte lessen en overgebleven dagen van je skipas.',
          },
        ]
      : []),
    ...(coverageTravels?.winterSportsAdditionallyInsured === true
      ? [
          {
            label: 'Wintersport',
            icon: 'green-check',
          },
        ]
      : []),
    ...(coverageTravels?.underwaterSportsAdditionallyInsured === true
      ? [
          {
            label: 'Onderwatersport',
            icon: 'green-check',
            content:
              'Hiermee krijg je dekking voor schade en eventuele kosten, zoals bij onverwacht vertrek naar huis. Veel reisverzekeringen vergoeden dan bijvoorbeeld de niet-gebruikte duiklessen en huur van duikuitrusting, evenals je eigen duikapparatuur.',
          },
        ]
      : []),
    ...(coverageTravels?.legalAidAdditionallyInsured === true
      ? [
          {
            label: 'Reisrechtsbijstand',
            icon: 'green-check',
            content:
              'Met de rechtsbijstandsdekking in je reisverzekering ben je verzekerd voor de kosten van juridische bijstand, gerelateerd aan je reis.',
          },
        ]
      : []),
    ...(coverageTravels?.businessTravelAdditionallyInsured === true
      ? [
          {
            label: 'Zakenreis',
            icon: 'green-check',
            content:
              'Op zakenreis gaan betekent niet automatisch dat je gedekt bent voor bijvoorbeeld bijkomende schade of terugreizen vanwege ziekte. Met deze extra dekking ben je hier wel voor verzekerd.',
          },
        ]
      : []),
    ...(coverageTravels?.roadsideAssistanceAdditionallyInsured === true
      ? [
          {
            label: 'Vervoer',
            icon: 'green-check',
            content:
              'Als je tijdens je vakantie of onderweg naar je bestemming autopech krijgt, dekt een aanvullende voertuighulpverzekering de kosten voor reparatie en eventuele sleepdiensten. Bovendien worden ook extra reis- en verblijfkosten vergoed.',
          },
        ]
      : []),
    ...(coverageTravels?.dangerousSportsAdditionallyInsured === true
      ? [
          {
            label: 'Gevaarlijke sporten',
            icon: 'green-check',
            content:
              'Sporten die als gevaarlijk worden beschouwd, zoals berg-, lucht- en watersporten, zijn niet standaard meeverzekerd bij reisverzekeringen. Met deze module ben je hiervoor verzekerd.',
          },
        ]
      : []),
  ];

  let coverageArea =
    coverageTravels?.coverageAreaCode?.[0] === 'VX' ? 'Europa' : 'Wereld';

  let travelDuration;
  switch (coverageTravels?.numberOfDaysCoverage) {
    case 45:
      travelDuration = 'Maximaal 6 weken';
      break;
    case 60:
      travelDuration = 'Maximaal 2 maanden';
      break;
    case 90:
      travelDuration = 'Maximaal 3 maanden';
      break;
    case 180:
      travelDuration = 'Maximaal 6 maanden';
      break;
    default:
      travelDuration = 'Maximaal 12 maanden';
  }

  const rightSideData = [
    // ...getGroupByFees(travelFees, ' Belangrijkste voorwaarden'),
    {
      list: [
        { label: 'Dekkingsgebied', value: coverageArea },
        {
          label: 'Eigen risico bagage',
          value: `€ ${coverageTravels?.deductibleAmount || '0'}`,
        },
        { label: 'Reisduur', value: travelDuration },
      ],
      title: 'Belangrijkste voorwaarden',
    },
    {
      children:
        provider?.type === 'krn:kizi:data-provider:risk' ? (
          <>
            {(
              provider?.coverageConditions as {
                urlAttachment: string;
                label: string;
              }[]
            )?.map((d) => (
              <DocumentUrl
                key={d.label}
                href={d.urlAttachment}
                label={d.label}
                mb={3}
              />
            ))}
            {provider?.documents?.map((d) => (
              <DocumentUrl href={d.url} label={d.label} key={d.label} />
            ))}
          </>
        ) : (
          <>
            <DocumentUrl
              href={insuranceCardUrl}
              label={'Bekijk dekkingskaart' + urlLabel}
              mb={3}
            />
            <DocumentUrl
              href={termsAndConditionsUrl}
              label={'Polisvoorwaarden' + urlLabel}
            />
          </>
        ),
      title: 'Verzekeringskaarten en Polisvoorwaarden',
    },
  ];

  return (
    <>
      <Div display={[null, null, 'flex']}>
        <Div>
          <List variant="accordionProductInner">
            {/* <ListItem>
              <Div>
                <P variant="bodyImportant">Wat is verzekerd?</P>
              </Div>
              <P variant="footnoteRegular">
                {' '}
                {providerName} werkt met pakketten. Daardoor kan het voorkomen
                dat hier een dekking staat die je niet hebt gekozen, maar waar
                je wel voor bent verzekerd.
              </P>
            </ListItem> */}
            {coveragesData.length > 0 && (
              <ListItem>
                <Div>
                  <P variant="footnoteImportant">Alles op een rijtje</P>
                </Div>
                <List variant="accordionProductListExeption">
                  <Accordion
                    type="pro-con"
                    items={coveragesData}
                    allowOneItemOpen
                  />
                </List>
              </ListItem>
            )}
          </List>
        </Div>
        <ListComp groups={rightSideData} />
      </Div>
    </>
  );
};

function getLabelByType(productType = '') {
  switch (productType) {
    case 'insurance/damage/building':
      return ' Woonhuis';
    case 'insurance/damage/home':
      return ' Inboedel';
    case 'insurance/damage/liability':
      return ' Aansprakelijkheid';
    default:
      return '';
  }
}

// const labelsToChange = {
//   '-32767': 'nvt',
//   '0': formatPrice(0, 0),
//   '1': 'green-check',
//   '32767': 'nvt',
//   '999999999': 'Onbeperkt',
//   ja: 'green-check',
//   nee: 'small-cancel',
// };

// function fieldByCategory(_fees: Fee[], category: Fee['category']): Field[] {
//   return _fees
//     .filter(
//       (fee) =>
//         fee.category === category &&
//         [
//           'Eigen risico bagage',
//           'Dekkingsgebied',
//           'Max reisduur std (dgn)',
//           'Sieraden',
//         ].includes(fee.label)
//     )
//     .map((fee) => {
//       let value = fee.value;

//       if (Object.keys(labelsToChange).includes(fee.value)) {
//         value = labelsToChange[fee.value];
//       }

//       if (Number(value)) {
//         value = 'tot ' + formatPrice(fee.value, 0);
//       }

//       return {
//         ...fee,
//         value,
//         valueIcon: ['green-check', 'small-cancel'].includes(value),
//       };
//     });
// }
